module.exports = __webpack_public_path__ + "media/assets/icons/people-525ebe0b07c11ee6fef7de48a1a9fb1f.svg";